/*      Dara - Agreement Version
 * All axios endpoints for agreement versions. They will be prefixed with /api/myhq-spa/agreement-version
 */
import axios from '@/plugins/axios'
import { useAppStore } from '@/stores/app'
import { useAgreementStore } from '@/stores/agreement'
import type { IGetAgreementVersion } from '@/interfaces/api/Dara/AgreementVersion'

export default {
  baseUrl() {
    const appStore = useAppStore()

    return `${appStore.daraApiBaseUrl}/agreement-versions/`
  },

  getAgreementVersion() {
    const agreementStore = useAgreementStore()

    return axios.get<IGetAgreementVersion, IGetAgreementVersion>(this.baseUrl() + agreementStore.agreementAmendmentId)
  },

  signCustomerAgreementVersion(id: number) {
    return axios.post(this.baseUrl() + id + '/sign-amendment')
  },
}
